import React from 'react'

import { IconPropsType } from '../types'

const MicrosoftEdgeBrowserIcon = (props: IconPropsType) => {
   const { width = 28, height = 28, ...rest } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         viewBox='0 0 28 29'
         fill='none'
         {...rest}
      >
         <g clip-path='url(#clip0_9780_73986)'>
            <path
               d='M25.2765 21.7207C24.9011 21.9158 24.5139 22.0875 24.1172 22.2348C22.861 22.7023 21.5309 22.9394 20.1906 22.9348C15.0172 22.9348 10.5109 19.3801 10.5109 14.8082C10.5176 14.196 10.6874 13.5967 11.0026 13.0718C11.3179 12.547 11.7673 12.1157 12.3047 11.8223C7.62341 12.0191 6.42029 16.8973 6.42029 19.752C6.42029 27.8457 13.8687 28.6551 15.4765 28.6551C16.3406 28.6551 17.6422 28.4035 18.4297 28.152L18.5718 28.1082C21.5856 27.0667 24.1547 25.0299 25.8562 22.3332C25.9057 22.2513 25.9269 22.1554 25.9166 22.0602C25.9064 21.9651 25.8652 21.8759 25.7994 21.8064C25.7336 21.7369 25.6469 21.6909 25.5524 21.6754C25.458 21.6599 25.3611 21.6758 25.2765 21.7207Z'
               fill='url(#paint0_linear_9780_73986)'
            />
            <path
               opacity='0.35'
               d='M25.2765 21.7207C24.9011 21.9158 24.5139 22.0875 24.1172 22.2348C22.861 22.7023 21.5309 22.9394 20.1906 22.9348C15.0172 22.9348 10.5109 19.3801 10.5109 14.8082C10.5176 14.196 10.6874 13.5967 11.0026 13.0718C11.3179 12.547 11.7673 12.1157 12.3047 11.8223C7.62341 12.0191 6.42029 16.8973 6.42029 19.752C6.42029 27.8457 13.8687 28.6551 15.4765 28.6551C16.3406 28.6551 17.6422 28.4035 18.4297 28.152L18.5718 28.1082C21.5856 27.0667 24.1547 25.0299 25.8562 22.3332C25.9057 22.2513 25.9269 22.1554 25.9166 22.0602C25.9064 21.9651 25.8652 21.8759 25.7994 21.8064C25.7336 21.7369 25.6469 21.6909 25.5524 21.6754C25.458 21.6599 25.3611 21.6758 25.2765 21.7207Z'
               fill='url(#paint1_radial_9780_73986)'
            />
            <path
               d='M11.5608 27.2777C10.5873 26.6731 9.74337 25.8812 9.07802 24.948C8.31824 23.9081 7.79524 22.7145 7.54574 21.4509C7.29623 20.1874 7.32627 18.8846 7.63373 17.6339C7.94119 16.3832 8.51863 15.2149 9.32553 14.2111C10.1324 13.2073 11.1492 12.3922 12.3046 11.823C12.6546 11.659 13.2343 11.3746 14.0108 11.3855C14.5573 11.3898 15.0953 11.5203 15.583 11.767C16.0706 12.0136 16.4946 12.3697 16.8218 12.8074C17.2619 13.3992 17.5031 14.1153 17.5108 14.8527C17.5108 14.8309 20.1905 6.14648 8.76083 6.14648C3.95927 6.14648 0.0108348 10.6965 0.0108348 14.6996C-0.00826372 16.8142 0.443826 18.9065 1.33427 20.8246C2.79254 23.9298 5.34017 26.3915 8.49356 27.7423C11.6469 29.0932 15.1866 29.2393 18.4405 28.1527C17.3005 28.5128 16.0959 28.621 14.91 28.4699C13.7241 28.3189 12.5851 27.9121 11.5718 27.2777H11.5608Z'
               fill='url(#paint2_linear_9780_73986)'
            />
            <path
               opacity='0.41'
               d='M11.5608 27.2777C10.5873 26.6731 9.74337 25.8812 9.07802 24.948C8.31824 23.9081 7.79524 22.7145 7.54574 21.4509C7.29623 20.1874 7.32627 18.8846 7.63373 17.6339C7.94119 16.3832 8.51863 15.2149 9.32553 14.2111C10.1324 13.2073 11.1492 12.3922 12.3046 11.823C12.6546 11.659 13.2343 11.3746 14.0108 11.3855C14.5573 11.3898 15.0953 11.5203 15.583 11.767C16.0706 12.0136 16.4946 12.3697 16.8218 12.8074C17.2619 13.3992 17.5031 14.1153 17.5108 14.8527C17.5108 14.8309 20.1905 6.14648 8.76083 6.14648C3.95927 6.14648 0.0108348 10.6965 0.0108348 14.6996C-0.00826372 16.8142 0.443826 18.9065 1.33427 20.8246C2.79254 23.9298 5.34017 26.3915 8.49356 27.7423C11.6469 29.0932 15.1866 29.2393 18.4405 28.1527C17.3005 28.5128 16.0959 28.621 14.91 28.4699C13.7241 28.3189 12.5851 27.9121 11.5718 27.2777H11.5608Z'
               fill='url(#paint3_radial_9780_73986)'
            />
            <path
               d='M16.6687 17.1598C16.5703 17.2691 16.2969 17.4332 16.2969 17.7723C16.2969 18.0566 16.4828 18.341 16.8219 18.5707C18.3859 19.6645 21.35 19.5113 21.3609 19.5113C22.5269 19.5106 23.6714 19.1971 24.675 18.6035C25.6854 18.0125 26.5238 17.1677 27.107 16.1528C27.6903 15.1379 27.9981 13.9881 28 12.8176C28.0328 10.3676 27.125 8.73789 26.7641 8.01602C24.4344 3.48789 19.4359 0.884766 14 0.884766C10.3208 0.884402 6.78939 2.33234 4.16947 4.91542C1.54954 7.4985 0.0517383 11.0091 0 14.6879C0.0546875 10.6957 4.025 7.46914 8.75 7.46914C9.13281 7.46914 11.3203 7.50195 13.3438 8.56289C14.7653 9.26929 15.9425 10.3855 16.7234 11.7676C17.3906 12.927 17.5109 14.4035 17.5109 14.9941C17.5109 15.5848 17.2156 16.4488 16.6578 17.1707L16.6687 17.1598Z'
               fill='url(#paint4_radial_9780_73986)'
            />
            <path
               d='M16.6687 17.1598C16.5703 17.2691 16.2969 17.4332 16.2969 17.7723C16.2969 18.0566 16.4828 18.341 16.8219 18.5707C18.3859 19.6645 21.35 19.5113 21.3609 19.5113C22.5269 19.5106 23.6714 19.1971 24.675 18.6035C25.6854 18.0125 26.5238 17.1677 27.107 16.1528C27.6903 15.1379 27.9981 13.9881 28 12.8176C28.0328 10.3676 27.125 8.73789 26.7641 8.01602C24.4344 3.48789 19.4359 0.884766 14 0.884766C10.3208 0.884402 6.78939 2.33234 4.16947 4.91542C1.54954 7.4985 0.0517383 11.0091 0 14.6879C0.0546875 10.6957 4.025 7.46914 8.75 7.46914C9.13281 7.46914 11.3203 7.50195 13.3438 8.56289C14.7653 9.26929 15.9425 10.3855 16.7234 11.7676C17.3906 12.927 17.5109 14.4035 17.5109 14.9941C17.5109 15.5848 17.2156 16.4488 16.6578 17.1707L16.6687 17.1598Z'
               fill='url(#paint5_radial_9780_73986)'
            />
         </g>
         <defs>
            <linearGradient
               id='paint0_linear_9780_73986'
               x1='6.42029'
               y1='20.2441'
               x2='25.9328'
               y2='20.2441'
               gradientUnits='userSpaceOnUse'
            >
               <stop stop-color='#0C59A4' />
               <stop offset='1' stop-color='#114A8B' />
            </linearGradient>
            <radialGradient
               id='paint1_radial_9780_73986'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(17.1937 20.3912) scale(10.4344 9.91266)'
            >
               <stop offset='0.7' stop-opacity='0' />
               <stop offset='0.9' stop-opacity='0.5' />
               <stop offset='1' />
            </radialGradient>
            <linearGradient
               id='paint2_linear_9780_73986'
               x1='16.7015'
               y1='11.7793'
               x2='4.52802'
               y2='25.0465'
               gradientUnits='userSpaceOnUse'
            >
               <stop stop-color='#1B9DE2' />
               <stop offset='0.2' stop-color='#1595DF' />
               <stop offset='0.7' stop-color='#0680D7' />
               <stop offset='1' stop-color='#0078D4' />
            </linearGradient>
            <radialGradient
               id='paint3_radial_9780_73986'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(7.71685 22.6443) rotate(-81.3844) scale(15.6828 12.6702)'
            >
               <stop offset='0.8' stop-opacity='0' />
               <stop offset='0.9' stop-opacity='0.5' />
               <stop offset='1' />
            </radialGradient>
            <radialGradient
               id='paint4_radial_9780_73986'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(2.83172 6.05995) rotate(92.2906) scale(22.1552 47.186)'
            >
               <stop stop-color='#35C1F1' />
               <stop offset='0.1' stop-color='#34C1ED' />
               <stop offset='0.2' stop-color='#2FC2DF' />
               <stop offset='0.3' stop-color='#2BC3D2' />
               <stop offset='0.7' stop-color='#36C752' />
            </radialGradient>
            <radialGradient
               id='paint5_radial_9780_73986'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(26.2566 9.33945) rotate(73.7398) scale(10.6422 8.65423)'
            >
               <stop stop-color='#66EB6E' />
               <stop offset='1' stop-color='#66EB6E' stop-opacity='0' />
            </radialGradient>
            <clipPath id='clip0_9780_73986'>
               <rect
                  width='28'
                  height='28'
                  fill='white'
                  transform='translate(0 0.884766)'
               />
            </clipPath>
         </defs>
      </svg>
   )
}

export default MicrosoftEdgeBrowserIcon
